import React, { Component } from 'react';
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

class LimitesCompra extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mensajeEdicionActivo: false,
            descripcionNovedad: "Editado"
        }

        this.obtenerFullDatosNovedad = this.obtenerFullDatosNovedad.bind(this);
    }
    /**
     * 
     * @param {any} activo
     */
    mostrarMensajeParaEdicion(activo) {
        this.setState({ mensajeEdicionActivo: activo });
    }
    /**
     * 
     * @param {any} activo
     */
    mostrarMensajeParaNovedad(descripcionNovedad) {
        this.setState({ descripcionNovedad });
    }
    /**
     * 
     * @param {any} novedad
     */
    obtenerFullDatosNovedad(novedades, data, codigoNovedad) {
        const novedad = novedades.find(x => x.NovedadCampoCodigo == codigoNovedad);
        const tieneNovedad = (novedad != undefined);
        const limite = data.ImporteLimiteSignature;

        let fechaModificacion = "";
        let fecha = "";
        let hora = "";
        let valorAnterior = "";
        let leyenda = {
            descripcion: "",
            estado: "",
            limite: limite,
            limiteFormato: GlobalHelper.ConvertirNumeroMilesMillones(limite),
            tieneNovedad
        };

        if (tieneNovedad) {
            fechaModificacion = novedad.FechaHoraModificacion.replace("T", " ").replace("Z", "");
            fecha = fechaModificacion.substring(0, 10).split("-");
            hora = fechaModificacion.substring(16, 11);
            valorAnterior = novedad.ValorAnteriorFormateado ? novedad.ValorAnteriorFormateado : novedad.ValorAnterior;

            //Cuando se genera una novedad por el panel de novedades se guarda el id, desde distribucion de limites se guarda el valor
            let limiteNovedadAnterior = data.accountData.GET_LIMITE_COMPRA.find(x => x.Id == novedad.ValorAnterior);
            if (!limiteNovedadAnterior) {
                limiteNovedadAnterior = data.accountData.GET_LIMITE_COMPRA.find(x => x.Valor == novedad.ValorAnterior);
            }

            let limiteNovedad = data.accountData.GET_LIMITE_COMPRA.find(x => x.Id == novedad.ValorNovedad);
            if (!limiteNovedad) {
                limiteNovedad = data.accountData.GET_LIMITE_COMPRA.find(x => x.Valor == novedad.ValorNovedad);
            }

            leyenda = {
                ...leyenda,
                descripcion: `Editado: ${fecha[2]} - ${fecha[1]}, ${hora} por ${novedad.UsuarioLoginModificacion}. Era: ${limiteNovedadAnterior.Valor}.`,
                estado: `Estado: ${novedad.NovedadEstadoDescripcion}.`,
                limite: limiteNovedad.Valor,
                limiteFormato: GlobalHelper.ConvertirNumeroMilesMillones(limiteNovedad.Valor)
            }
        }

        return leyenda;
    }

    render() {
        const { props } = this;
        const novedad = this.obtenerFullDatosNovedad(props.dataCompleto.novedadesCuentaDatos, props.data, props.codigoNovedad);
        let mensajeEditado = null;

        if (novedad.tieneNovedad) {
            mensajeEditado = <div className="col-xs-12">
                <label className="label-secondary color-azul-claro"
                    onMouseEnter={() => this.mostrarMensajeParaNovedad(novedad.descripcion)}
                    onMouseLeave={() => this.mostrarMensajeParaNovedad("Editado")}>{this.state.descripcionNovedad}</label>
            </div>
        }

        return (
            <div className="row">
                <div className="col-xs-4">
                    <div>
                        <label className="label-primary">Límite de compra</label>
                    </div>
                    <div>
                        <label className="label-secondary edit-panel-lapiz"
                            onMouseEnter={() => this.mostrarMensajeParaEdicion(true)}
                            onMouseLeave={() => this.mostrarMensajeParaEdicion(false)}>$ {novedad.limiteFormato}</label>
                    </div>
                </div>

                {this.state.mensajeEdicionActivo &&
                    <div className="col-xs-8">
                        <label className="label-primary">Se debe modificar en la Distribución de Límites.</label>
                    </div>}

                {mensajeEditado}
            </div>
        );
    }
}

export default LimitesCompra;